import { Box, BoxProps, Typography, TypographyProps } from "@mui/material";
import { ReactNode, useId } from "react";
import styles from "./SettingsCardField.module.css";

export interface SettingsCardFieldProps {
	custom?: {
		orientation?: "vertical" | "horizontal";
	};
	renderers: {
		label: {
			titleRenderer: () => ReactNode;
			subTitleRenderer: () => ReactNode;
		};
	};
	slots?: {
		contentField?: BoxProps;
		contentFieldHeader?: BoxProps;
		contentFieldTitle?: TypographyProps;
		contentFieldSubTitle?: TypographyProps;
	};
	children?: (titleId: string) => ReactNode;
}

export function SettingsCardField({ renderers, custom, children, slots }: SettingsCardFieldProps) {
	const titleId = useId();
	return (
		<Box
			className={`${styles.contentField} ${custom?.orientation === "horizontal" && styles.horizontal}`}
			{...slots?.contentField}
		>
			<Box className={styles.contentFieldHeader} {...slots?.contentFieldHeader}>
				<Typography id={titleId} className={styles.contentFieldTitle} {...slots?.contentFieldTitle}>
					{renderers?.label?.titleRenderer()}
				</Typography>
				<Typography className={styles.contentFieldSubTitle} {...slots?.contentFieldSubTitle}>
					{renderers?.label?.subTitleRenderer()}
				</Typography>
			</Box>
			{children && children(titleId)}
		</Box>
	);
}
